module.exports = "/_next/static/images/lj-4cad7e8b9e36d5e9fee29905279c0dfc.png";